import { render } from "./SelectTokenModal.vue?vue&type=template&id=71ba6c0b&scoped=true"
import script from "./SelectTokenModal.vue?vue&type=script&lang=js"
export * from "./SelectTokenModal.vue?vue&type=script&lang=js"

import "./SelectTokenModal.vue?vue&type=style&index=0&id=71ba6c0b&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src338202144/src/web-app-vue-3/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71ba6c0b"]])

export default __exports__